
























































import { Vue, Component, Prop } from "vue-property-decorator";
import { ITaxTemplate } from "@/models/tax";

@Component
export default class TaxTemplateGridItem extends Vue {
  // Props

  @Prop({ default: null })
  public taxTemplate!: ITaxTemplate | null;

  @Prop({ default: false })
  public canUpdate!: boolean;

  @Prop({ default: false })
  public canDelete!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public isLoading!: boolean;
}
